import { render, staticRenderFns } from "./PageTitleWithSearch.vue?vue&type=template&id=2f5bd546"
import script from "./PageTitleWithSearch.vue?vue&type=script&lang=js"
export * from "./PageTitleWithSearch.vue?vue&type=script&lang=js"
import style0 from "./PageTitleWithSearch.vue?vue&type=style&index=0&id=2f5bd546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports